import { render } from "./impressumSection.vue?vue&type=template&id=6f9b3c12"
import script from "./impressumSection.vue?vue&type=script&lang=js"
export * from "./impressumSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__